import { Avatar, Box, IconButton, IconButtonProps, Tooltip, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { ActivityListProps } from "./types"
import CustomAccordion from "../../../../../../../components/accordion"
import { ActivityItem } from "../activityItem"
import { NoResponse } from "../../../../../../../components/errors/noResponse"
import { ScrollContainer } from "../../../../../../../components/scrollContainer"
import { CustomeIconButton } from "../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../utils/icons"
import { useEffect, useMemo, useState } from "react"
import { ActivityListHeader } from "../activityListHeader"
import { Status } from "../../../../../../../utils/enums"
import Loader from "../../../../../../../components/loader"
import { activityListToUser } from "../../../utils/types/activity"
import { Virtuoso } from "react-virtuoso"

export const ActivityAccordionList = ({ list, title, amount, completedLogs, id, usersToView, /* isVisible, visibility, userId, */ displayActivityListUsers, usersToDisplayed, menuOption, area, curp, deaprtment, division, role, getActivities, query, types }: ActivityListProps) => {
    const styles = useStyles()
    const { t } = useTranslation()
    //const [visibleCopy, setVisibleCopy] = useState(true)
    const [expanded, setExpanded] = useState(false)
    const [arrayExpand, setArrayExpand] = useState<{
        id: string;
        clave: boolean;
    }[] | undefined>()
    const [listLocal, setListLocal] = useState<activityListToUser | undefined[] | null>(null)
    const [allExpand, setAllExpand] = useState(false)

    const [localLoad, setLocalLoad] = useState(false)
    //const [types, setTypes] = useState<{ count: number; type: Status }[]>([])

    const isVisibleCalculated = () => {
        if (usersToDisplayed.some((user) => user.startsWith(id)) || usersToView.some((user) => user.startsWith(id))) {
            if (visibleCopy) {
                return !usersToDisplayed.some((user) => user.startsWith(id));
            } else {
                return usersToView.some((user) => user.startsWith(id));
            }
        } else {
            return false
        }
    };
    const [visibleCopy, setVisibleCopy] = useState(true);
    const [isVisible, setIsVisible] = useState(() => !!list.length && isVisibleCalculated());
    //const isVisible = !!list.length && isVisibleValidate();
    const allAreTrue = useMemo(() => {
        return !!arrayExpand?.every(item => item.clave === true);
    }, [arrayExpand]);

    const allAreFalse = useMemo(() => {
        return !!arrayExpand?.every(item => item.clave === false);
    }, [arrayExpand]);
    const activitiesAmounts = `${completedLogs}/${amount}`
    const ids = useMemo(() => list.map(item => `${id}-${item.id}`), [list]);
    const visibility: Partial<IconButtonProps> = {
        color: 'primary',
        onClick: (e) => {
            e.stopPropagation();
            displayActivityListUsers({ users: id, list: true, visible: !isVisible, activitiesId: ids });
        },
    };

    const expasnded: Partial<IconButtonProps> = {
        color: 'primary',
        onClick: (e) => {
            e.stopPropagation();
            setAllExpand(!allExpand)
            const nuevosDatos = arrayExpand?.map(item => ({
                ...item,
                clave: !allExpand
            }));
            setArrayExpand(nuevosDatos);
            if (!allExpand) {
                setExpanded(true)
            }
        },
    };

    const toggleExpand = () => {
        setExpanded(!expanded)
    }

    /* const assignData = async () => {
        setLocalLoad(true)
        const response = await getActivities({ ids: [String(id)], onlyUser: true, query: query })
        const activityList = response.transform.oneUser?.activityList
        setListLocal(activityList ?? [])
        const nuevoArray = activityList?.map(item => ({
            id: item.id,
            clave: allExpand // o false, dependiendo de tu lógica
        }));
        setArrayExpand(nuevoArray)
        setTypes(response.transform.oneUser?.types ?? [])
        setLocalLoad(false)
    } */

    const expandChild = (id: string, value: boolean) => {
        const nuevosDatos = arrayExpand?.map(item =>
            item.id == id ? { ...item, clave: value } : item
        );
        setArrayExpand(nuevosDatos)
    }

    useEffect(() => {
        /* if (expanded && listLocal === null) {
            setLocalLoad(true);
            // Simula carga diferida (puedes reemplazar esto con getActivities si es necesario)
            const timeout = setTimeout(() => {
                setListLocal(list ?? []);
                const nuevoArray = list?.map(item => ({
                    id: item.id,
                    clave: allExpand
                }));
                setArrayExpand(nuevoArray);
                setLocalLoad(false);
            }, 300); // tiempo simulado

            return () => clearTimeout(timeout); // limpieza por si el componente se desmonta
        } */
        if (expanded) {
            if (!listLocal) {
                setLocalLoad(true);
                const timeout = setTimeout(() => {
                    setListLocal(list ?? []);
                    const nuevoArray = list?.map(item => ({
                        id: item.id,
                        clave: allExpand
                    }));
                    setArrayExpand(nuevoArray);
                    setLocalLoad(false);
                }, 300); // Simula carga; reemplaza con getActivities si quieres
                return () => clearTimeout(timeout);
            }
        } else {
            // Limpia cuando se contrae
            setListLocal(null);
            setArrayExpand(undefined);
        }
    }, [expanded]);

    /* useEffect(() => {
        if (!listLocal && (expanded || allExpand)) {
            assignData()
            //hacerf el llamado de la data
        }
    }, [expanded, allExpand]) */

    /* useEffect(() => {
        setListLocal(list ?? [])
        const nuevoArray = list?.map(item => ({
            id: item.id,
            clave: allExpand // o false, dependiendo de tu lógica
        }));
        setArrayExpand(nuevoArray)
        //setTypes(types ?? [])
    }, [list]) */

    useEffect(() => {
        if (allAreTrue) {
            setAllExpand(true)
        }
        if (allAreFalse) {
            setAllExpand(false)
        }
    }, [allAreTrue, allAreFalse])

    useEffect(() => {
        const validate = isVisibleCalculated();
        setIsVisible(!!list.length && validate);

        if (visibleCopy && validate) {
            setVisibleCopy(false);
        } else if (!visibleCopy && !validate) {
            setVisibleCopy(true);
        }
    }, [usersToDisplayed, usersToView, id, list.length]);

    return (
        <CustomAccordion
            title={(
                <Box sx={styles.alignHorizontal}>
                    <Box>
                        <Tooltip title={t(`ToolTips.${expanded ? 'collapse' : 'expand'}`)}>
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleExpand();
                                }}
                                sx={[styles.arrow, styles.rotate(expanded)]}
                            >{icons('arrow-down')} </IconButton>
                        </Tooltip>

                        <Typography variant="subtitle_grey" fontWeight='bold'>{title || t('loogbook.titles.activityList')}</Typography>
                    </Box>

                    <Box sx={styles.rightActions}>
                        <Tooltip title={t('general.activitiesCompletedAndPending')}><Avatar sx={styles.avatar}>{activitiesAmounts}</Avatar></Tooltip>
                        <CustomeIconButton title={t(`general.${isVisible ? 'hiddenUser' : 'showUser'}`)} icon={icons(isVisible ? 'visibility' : 'visibility-off')} iconButtonProps={visibility} />
                    </Box>
                </Box>
            )}
            description={
                <>
                    {localLoad ?
                        <Loader />
                        :
                        <Virtuoso
                            style={styles.list as any}
                            totalCount={listLocal?.length}
                            components={{
                                Header: () => (
                                    <ActivityListHeader
                                        area={area}
                                        curp={curp}
                                        department={deaprtment}
                                        division={division}
                                        rol={role}
                                        total={amount ?? 0}
                                        types={types}
                                        more
                                        allExpand={allExpand}
                                        expasnded={expasnded}
                                    />
                                ),
                                EmptyPlaceholder: () => (
                                    <NoResponse label={t('general.noActivities')} />
                                ),
                            }}
                            itemContent={(index) => {
                                const userActivity = listLocal?.[index]
                                return (
                                    <ActivityItem
                                        key={userActivity?.id}
                                        menuOption={menuOption}
                                        assignData={getActivities}
                                        {...userActivity}
                                        scheduledVisitId={userActivity?.scheduleVisitId}
                                        modelId={userActivity?.modelId}
                                        model={userActivity?.model}
                                        isVisible={!usersToDisplayed.some(user => user == userActivity?.id) && usersToView.some((user) => user == userActivity?.id)}
                                        toggleExpand={expandChild}
                                        visibility={{
                                            color: 'primary', onClick: (e) => {
                                                e.stopPropagation()
                                                displayActivityListUsers({ users: userActivity?.id })
                                            }
                                        }}
                                        expandParent={arrayExpand?.find(item => item.id === userActivity?.id)?.clave ?? false}
                                    />
                                )
                            }}
                        />
                    }
                </>
            }
            expandIcon={null}
            expanded={expanded}
        />

    )
}